// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "gz-input-validation p{color:#f44336}", "",{"version":3,"sources":["/usr/local/ado-agent/_work/1/s/node_modules/@printos/gazelle/src/components/input-validation/input-validation.scss"],"names":[],"mappings":"AACE,sBACE,aAAA","file":"input-validation.scss","sourcesContent":["gz-input-validation {\n  p {\n    color: rgb(244,67,54); // Taken from MD error values\n  }\n}\n"]}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
